export const MISSING_SHARE_OK = 0.01;
export const LATE_SHARE_OK = 0.05;
export function aboutHealth(report, selectedModel) {
    const m = report.meta;
    const missingOk = (m.reconciliation.missingShare ?? 0) <= MISSING_SHARE_OK;
    const lateOk = (m.lateShare ?? 0) <= LATE_SHARE_OK && (m.incompleteShare ?? 0) <= LATE_SHARE_OK;
    const warnings = [];
    let version = 'current';
    if (selectedModel) {
        version = m.availableModelVersions.includes(selectedModel) ? 'pinned' : 'absent';
        if (version === 'absent')
            warnings.push(`версия ${selectedModel} не встречается в окне`);
    }
    if (!selectedModel && m.activeVersionSource === 'latest-scoredAt') {
        warnings.push('активная версия не задана настройкой — показана самая свежая');
    }
    if (m.latestScoredVersion && m.modelVersion && m.latestScoredVersion !== m.modelVersion) {
        warnings.push(`есть более свежая версия: ${m.latestScoredVersion}`);
    }
    const versionOk = warnings.length === 0;
    return {
        ok: missingOk && versionOk && lateOk,
        missingOk,
        versionOk,
        lateOk,
        version,
        versionWarnings: warnings,
    };
}
/**
 * Последний день ОКНА отчёта, который уже не предварительный. Это не свежесть
 * данных: на прошлой неделе он равен её воскресенью. Свежесть расхода —
 * `freshness.snapshotsFinalizedThrough`; эта функция нужна только чтобы понять,
 * есть ли в выбранном периоде предварительные дни (`periodHasPreliminary`).
 */
export function closedThrough(report, fallback) {
    const pre = new Set(report.preliminaryDays);
    let d = report.meta.to;
    for (let i = 0; i < 400 && d >= report.meta.from; i++) {
        if (!pre.has(d))
            return d;
        d = new Date(Date.parse(`${d}T00:00:00Z`) - 86_400_000).toISOString().slice(0, 10);
    }
    return fallback;
}
/** В выбранном периоде есть дни с предварительным (ещё не закрытым) расходом. */
export function periodHasPreliminary(report) {
    return closedThrough(report, null) !== report.meta.to;
}
//# sourceMappingURL=about-logic.js.map